import { ReactNode } from "react";

type Props = {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  actions?: ReactNode;
};

export function PageHeader({ title, subtitle, eyebrow, actions }: Props) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        gap: 16,
        flexWrap: "wrap",
        marginBottom: 24,
      }}
    >
      <div>
        {eyebrow && (
          <div
            style={{
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: ".09em",
              color: "var(--fg-subtle)",
              fontWeight: 600,
              marginBottom: 4,
            }}
          >
            {eyebrow}
          </div>
        )}
        <h1
          className="display"
          style={{
            fontSize: 30,
            margin: 0,
            color: "var(--brand-900)",
            fontWeight: 400,
            lineHeight: 1.1,
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <div style={{ fontSize: 13, color: "var(--fg-muted)", marginTop: 6 }}>{subtitle}</div>
        )}
      </div>
      {actions && (
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>{actions}</div>
      )}
    </div>
  );
}
